<div class="file-summary-card" *ngIf="itinerary">
  <div class="summary-item" *ngIf="itinerary?.nombreItinerario">
    <div class="summary-label">Nombre Itinerario</div>
    <div class="summary-value">{{ itinerary?.nombreItinerario }}</div>
  </div>

  <div class="summary-item">
    <div class="summary-label">Estado File</div>
    <div class="summary-value">
      {{ itinerary?.fileDisplayState }}
      <ng-container *ngIf="interactive">
        <ng-container
          *ngIf="
            itinerary?.fileDisplayState !== 'REVISAR' &&
            itinerary?.fileDisplayState !== 'CONFIRMADO'
          "
        >
          <mat-icon>
            <i-tabler
              name="pencil"
              matTooltip="Editar estado del file"
              matTooltipPosition="above"
              class="icon-resolved icon-edit icon-size"
              (click)="editState.emit(itinerary)"
            ></i-tabler>
          </mat-icon>
        </ng-container>
        <ng-container
          *ngIf="
            itinerary?.fileDisplayState !== 'REVISAR' &&
            itinerary?.fileDisplayState === 'CONFIRMADO'
          "
        >
          <mat-icon>
            <i-tabler
              name="pencil"
              matTooltip="Que ventas valide y proceda a reconfirmar el file"
              matTooltipPosition="above"
              class="icon-gray icon-edit icon-size"
            ></i-tabler>
          </mat-icon>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div
    class="summary-item"
    *ngIf="interactive || itinerary?.pendingPreOpIncidents != null"
  >
    <div class="summary-label">Incidentes Pre-Operativos</div>
    <div class="summary-value">
      <ng-container
        *ngIf="
          itinerary?.pendingPreOpIncidents != null;
          else withoutPreOpIncident
        "
      >
        <div
          class="review-icon-container"
          [class.review-icon-container--static]="!interactive"
          (click)="interactive && preOperationalIncidents.emit(itinerary)"
          style="justify-content: flex-start"
        >
          <ng-container
            *ngIf="
              itinerary?.pendingPreOpIncidents === 0;
              else hasPendingPreOpIncidents
            "
          >
            <i-tabler
              name="message-report"
              class="icon-tabler-review icon-check"
              matTooltip="Incidentes Pre Operativos Aprobados"
              matTooltipPosition="above"
            ></i-tabler>
            <div class="review-badge">
              <i-tabler
                name="circle-check-filled"
                matTooltip="Incidentes Pre Operativos Aprobados"
                matTooltipPosition="above"
                class="icon-tabler-check icon-check"
              ></i-tabler>
            </div>
          </ng-container>
          <ng-template #hasPendingPreOpIncidents>
            <i-tabler
              name="message-report"
              matTooltip="Incidentes Pre Operativos Pendientes"
              matTooltipPosition="above"
              class="icon-tabler-review icon-resolved"
            ></i-tabler>
            <div class="review-badge badge-red">
              {{ itinerary?.pendingPreOpIncidents }}
            </div>
          </ng-template>
        </div>
      </ng-container>

      <ng-template #withoutPreOpIncident>
        <div
          style="display: flex; gap: 8px"
          *ngIf="interactive; else dashIncidents"
        >
          <button
            mat-icon-button
            type="button"
            (click)="preOperationalIncidents.emit(itinerary)"
          >
            <i-tabler
              name="message-report"
              matTooltip="Sin Revisión de Programación"
              matTooltipPosition="above"
              class="icon-tabler-file icon-gray"
            ></i-tabler>
          </button>
        </div>
        <ng-template #dashIncidents>
          <span>-</span>
        </ng-template>
      </ng-template>
    </div>
  </div>

  <div class="summary-item">
    <div class="summary-label">Número</div>
    <div class="summary-value">
      {{ itinerary?.fileNumber }}{{ itinerary?.fileExtend }}
    </div>
  </div>

  <div class="summary-item">
    <div class="summary-label">Nombre Agencia</div>
    <div class="summary-value">{{ itinerary?.fileName || "-" }}</div>
  </div>

  <div class="summary-item" *ngIf="itinerary?.usuario">
    <div class="summary-label">DS</div>
    <div class="summary-value">{{ itinerary?.usuario }}</div>
  </div>

  <div class="summary-item" *ngIf="dataSourcePax">
    <div class="summary-label">Restricciones Alimenticias</div>
    <div
      class="summary-value"
      style="display: block; font-size: 0.9rem; line-height: 1.4"
    >
      <div *ngIf="!itinerary?.lstPaX?.length && dataSourcePax">
        No hay restricciones
      </div>
      <div *ngFor="let pax of dataSourcePax?.data" style="margin-bottom: 2px">
        <span *ngIf="pax?.pasajero?.restriccionesAlimentarias">
          &bull; {{ pax?.pasajero?.restriccionesAlimentarias }}
        </span>
      </div>
    </div>
  </div>

  <div class="summary-item">
    <div class="summary-label">Guía Principal</div>
    <div class="summary-value">
      {{ itinerary?.mainGuide?.providerName || "-" }}
    </div>
  </div>

  <div class="summary-item" *ngIf="itinerary?.observaciones != null">
    <div class="summary-label">Observaciones</div>
    <div class="summary-value" style="font-size: 0.9rem">
      {{ itinerary?.observaciones ? itinerary?.observaciones : "-" }}
    </div>
  </div>
</div>
